import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import * as cartSlice from "../../store/cart"
import { getSrc } from "../../utilities/enumerations/constants"

import "./CartDealCard.css"

export default function CartDealCard({ item, index, products }) {
  const dispatch = useDispatch()
  const cartState = useSelector((state) => state.cart)
  const [collapse, setCollapse] = useState(false)

  const handleChange = (e, dealProduct, productIndex) => {
    let swap = prompt("Would you like to add swap charges?", 50)
    if (!swap) swap = 0

    const selectedProduct = products[e.target.selectedIndex]
    const swapDealProduct = {
      itemIndex: index,
      productIndex,
      dealProduct: {
        id: dealProduct.id, // don't need this for order, added for same structure 
        product_id: selectedProduct.id,
        deal_id: dealProduct.deal_id,
        quantity: dealProduct.quantity,
        product: {
          title: selectedProduct.title,
          cost: selectedProduct.cost,
          price: selectedProduct.price
        },
        original_product: dealProduct
      }
    }
    if (swap) swapDealProduct.dealProduct.swap = parseFloat(swap)
    dispatch(cartSlice.swapDealProduct(swapDealProduct))
  }

  const handleClick = (dealId, productIndex) => {
    dispatch(cartSlice.removeSwapDealProduct({
      itemIndex: index,
      productIndex
    }))
  }

  const cart = cartState.posById[item.slug]
  const sale = item.price - item.discount
  const swap = item.deal_products.reduce((p, c) => p += c.swap || 0, 0)

  return (
    <li className="list-group-item list-group-item-cart p-2">
      <div className="d-flex gap-2 justify-content-between align-items-center" onClick={() => setCollapse(!collapse)}>
        <img src={getSrc(item.thumbnail_url)} alt={item.title} width={40} height={40} className="border rounded-3" />
        <div className="flex-grow-1">
          <p className="fs-12 text-body-emphasis fw-bold m-0">{item.title}</p>
          <p className="fs-12 text-body-secondary fw-bold m-0">x{cart} = {(cart * sale).toFixed(2)}</p>
        </div>
        <i className={`fs-10 bi bi-chevron-${collapse ? 'up' : 'down'}`}></i>
      </div>
      {!collapse && products && item.deal_products.map((dealProduct, productIndex) => {
        console.log(dealProduct)
        return (
          <div className="d-flex gap-2 justify-content-between align-items-center mt-1" key={`product-deal-${productIndex.toString()}`}>
            <select className="form-select form-select-sm rounded-3" onChange={(e) => handleChange(e, dealProduct, productIndex)} value={dealProduct.product_id}>
              {products.map((option, optionIndex) => <option key={`deal-product-select-${optionIndex.toString()}`} value={option.id}>{option.title}</option>)}
            </select>
            <p className="flex-shrink-0 fs-10 text-body-tertiary fw-bold m-0">x{dealProduct.quantity}={(dealProduct.quantity * dealProduct.product.price).toFixed(2)}</p>
            {dealProduct.swap > 0 && <div className="flex-shrink-0 bg-success-subtle d-flex gap-1 rounded px-1">
              <span className="fs-10 fw-bold text-success">+ {dealProduct.swap}</span>
              <span className="fs-10 fw-bold text-danger"><i className="bi bi-trash swap-x" onClick={() => handleClick(item.id, productIndex)}></i></span>
            </div>}
          </div>
        )
      })}
      {!collapse && !products && item.deal_products.map((dealProduct, productIndex) => {
        return (
          <div className="d-flex gap-2 justify-content-between align-items-center mt-1" key={`product-deal-${productIndex.toString()}`}>
            <p className="flex-grow-1 fs-10 text-body-tertiary fw-semibold m-0">{dealProduct.product.title}</p>
            <p className="flex-shrink-0 fs-10 text-body-tertiary fw-semibold m-0">x{dealProduct.quantity}={(dealProduct.quantity * dealProduct.product.price).toFixed(2)}</p>
            {dealProduct.swap > 0 && <div className="flex-shrink-0 bg-success-subtle d-flex gap-1 rounded px-1">
              <span className="fs-10 fw-bold text-success">+ {dealProduct.swap}</span>
            </div>}
          </div>
        )
      })}
      {!collapse && <div className="bg-secondary mt-1 border rounded-3 p-2">
        <div className="d-flex justify-content-between">
          <p className="fs-10 text-body-tertiary fw-bold m-0">Sub Total</p>
          <p className="fs-10 text-body-tertiary fw-bold m-0">Rs. {(cart * item.price).toFixed(2)}</p>
        </div>
        <div className="d-flex justify-content-between">
          <p className="fs-10 text-danger fw-bold m-0">Discount</p>
          <p className="fs-10 text-danger fw-bold m-0">Rs. {(cart * item.discount).toFixed(2)}</p>
        </div>
        <div className="d-flex justify-content-between">
          <p className="fs-10 text-success fw-bold m-0">Swap</p>
          <p className="fs-10 text-success fw-bold m-0">Rs. {(cart * swap).toFixed(2)}</p>
        </div>
        <div className="d-flex justify-content-between">
          <p className="fs-10 text-body-secondary fw-bold m-0">Total</p>
          <p className="fs-10 text-body-secondary fw-bold m-0">Rs. {(cart * (sale + swap)).toFixed(2)}</p>
        </div>
      </div>}
    </li>
  )
}